import { render } from "./MeFB.vue?vue&type=template&id=665588c1&scoped=true"
import script from "./MeFB.vue?vue&type=script&lang=js"
export * from "./MeFB.vue?vue&type=script&lang=js"

import "./MeFB.vue?vue&type=style&index=0&id=665588c1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665588c1"]])

export default __exports__